import React from 'react';
import { Dialog, DialogActions, DialogContent, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import type { ComparisonItem, ComparisonItemSourceFields } from '../../../../../types/BaselineMeasurements';
import { TranslationKeys } from '../../../../../translations';
import { ActionButton } from '../../../../../components';
import { useIntl } from 'react-intl';

type ComparisonDuplicatedInsurerDataDialogProps = {
  comparisonItem: ComparisonItem;
  onCloseDialog: () => void;
  onConfirmDialog: () => void;
  openDialog: boolean;
  excludeFields?: Array<keyof ComparisonItemSourceFields>;
};

export const ComparisonDuplicatedInsurerDataDialog = ({
  onCloseDialog,
  onConfirmDialog,
  openDialog,
  comparisonItem,
  excludeFields = ['id', 'sourceType'],
}: ComparisonDuplicatedInsurerDataDialogProps) => {
  const intl = useIntl();
  const fields = comparisonItem.insurerSource;
  const duplicatedItems = comparisonItem.duplicateInsurerSource;

  return (
    <Dialog
      open={openDialog}
      title="Duplicated insurer data"
      fullWidth={true}
      maxWidth="lg"
      onClose={() => {
        onCloseDialog();
      }}
    >
      <DialogContent>
        <Table stickyHeader size="small" aria-label="duplicated-insurer-data" sx={{ padding: 0 }}>
          <TableHead>
            <TableRow>
              {(Object.keys(fields) as Array<keyof ComparisonItemSourceFields>)
                .filter(field => !excludeFields.includes(field))
                .map((field, index) => (
                  <TableCell key={index} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    {intl.formatMessage({
                      id: `baseline.comparison.item.field.${field}`,
                    })}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ backgroundColor: 'success.light' }}>
              {(Object.keys(fields) as Array<keyof ComparisonItemSourceFields>)
                .filter(field => !excludeFields.includes(field))
                .map(field => {
                  const insurerValue = comparisonItem.insurerSource[field as keyof typeof comparisonItem.insurerSource];
                  return (
                    <TableCell
                      sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}
                      key={'item-compared-' + field + '-value'}
                    >
                      {insurerValue}
                    </TableCell>
                  );
                })}
            </TableRow>
            {duplicatedItems &&
              duplicatedItems.map((item, index) => (
                <TableRow key={index}>
                  {(Object.keys(fields) as Array<keyof ComparisonItemSourceFields>)
                    .filter(field => !excludeFields.includes(field))
                    .map(field => {
                      const insurerValue = item[field as keyof typeof comparisonItem.insurerSource];
                      return (
                        <TableCell
                          sx={{ whiteSpace: 'nowrap' }}
                          key={'item-not-compared-' + index + '-' + field + '-value'}
                        >
                          {insurerValue}
                        </TableCell>
                      );
                    })}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <ActionButton messageId={TranslationKeys.close} onClick={() => onConfirmDialog()} />
      </DialogActions>
    </Dialog>
  );
};
